import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
export interface modelState {
    BIURL: string;
    BIID:number;
}

const initialState: modelState = {
    BIURL: '',
    BIID:0
}

export const Slice = createSlice({
    name: 'dashboardLoader',
    initialState,
    reducers: {

        dashboardLoaderSet: (state, action) => {
            
            const { BIURL,BIID } = action.payload;
            state.BIURL = BIURL;
            state.BIID=BIID;
            //state=action.payload
        }
    },
})

// Action creators are generated for each case reducer function
export const { dashboardLoaderSet } = Slice.actions

export default Slice.reducer